import type { WorktimeSettlementStatus } from "../../services/types/worktimeSettlement";

type DecisionBadgePresentation = {
  label: string;
  color: "informative" | "success" | "danger";
  appearance: "tint";
};

const DECISION_BADGE_PRESENTATION: Record<WorktimeSettlementStatus, DecisionBadgePresentation> = {
  pending: { label: "Oczekuje", color: "informative", appearance: "tint" },
  accepted: { label: "Zaakceptowano", color: "success", appearance: "tint" },
  rejected: { label: "Odrzucono", color: "danger", appearance: "tint" },
};

export function resolveResourceAllocationDecision(
  status: WorktimeSettlementStatus | null,
  hasOrders: boolean
): WorktimeSettlementStatus | null {
  if (status) return status;
  return hasOrders ? "pending" : null;
}

export function resolveDecisionBadgePresentation(
  decision: WorktimeSettlementStatus | null
): DecisionBadgePresentation | null {
  if (!decision) return null;
  return DECISION_BADGE_PRESENTATION[decision];
}

export function resolveRejectedStatusMeta(): { label: string } {
  return {
    label: "Możesz zaakceptować rozliczenie lub wejść w szczegóły pracownika i zmodyfikować zlecenia",
  };
}

export function formatRejectionDetailLine(
  detail: { managerLastName: string; projectName: string; rejectionReason: string }
): string {
  return `${detail.managerLastName} · ${detail.projectName} · ${detail.rejectionReason}`;
}
